<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div style="">
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增" fontSize="14px" @btnclick="adduser">
      </Commonbtn>
      <Commonbtn v-if="qx.update" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="updateclick">
      </Commonbtn>
      <Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除" fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="del">
      </Commonbtn>
      <!-- <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/look.png')" title="查看详情" fontSize="14px" @btnclick="look">
      </Commonbtn> -->
      <!-- <Commonbtn v-if="qx.enabled" backgroundColor="#FFF" :src="require('@/assets/icon/qy.png')" title="启用" fontSize="14px" @btnclick="qy">
      </Commonbtn> -->
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" @handleSelectionChange="handleSelectionChange" colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" title="新增Banner" rigthText="确定" :dialogVisible="dialogVisibleNewInformationAdd" @cancel="cancelNewInformation" @dialogOK="dialogOKNewInformation">
      <div class="CusBannerDialog">
        <FromComm :FromArr="FromArrs" ref="FromArrs" ></FromComm>
        <div style="display: inline-block;position: relative;left:480px;top: -45px;">
          <CommonUploadEnclosure imgTitle="上传图片" title="Banner图片："
           enclCss1="position: relative;top: -27px;left: 100px;" 
           enclCss2="position: relative;top: 10px;left: 110px;font-weight: 600;"
           Mask="position: relative;top: -27px;left: 100px;"
           :fontWeight="500" :typeUpload="2" @getFile="DataManageAddUpload" :BLPhotoURL="fileURL"></CommonUploadEnclosure>
           <div style="position: relative;left: 116px;top: -62px;font-size: 13px;">
           (建议尺寸：1600*640)
           </div>
        </div>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="修改Banner" rigthText="修改" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="CusBannerDialog">
        <FromComm :FromArr="FromArrs" ></FromComm>
        <div style="display: inline-block;position: relative;left:480px;top: -45px;">
          <CommonUploadEnclosure imgTitle="上传图片" 
          enclCss1="position: relative;top: -27px;left: 100px;" 
          enclCss2="position: relative;top: 10px;left: 110px;font-weight: 600;"
          Mask="position: relative;top: -27px;left: 100px;" title="Banner图片：" :fontWeight="500" :typeUpload="2"
           @getFile="DataManageAddUpload" :BLPhotoURL="fileURL"></CommonUploadEnclosure>
           <div style="position: relative;left: 116px;top: -62px;font-size: 13px;">
           (建议尺寸：1600*640)
           </div>
        </div>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条数据吗？</span>
    </Dialog>

  </div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import Dialog from '../../../../components/dialog.vue'
import CommonUploadEnclosure from '../../../../components/common-upload-Enclosure.vue'
import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
import Upload from '../../../../components/common-upload'
import CommUploadAdditional from '../../../../components/comm-upload-additional.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import FromArr from '../fromData/FromArr'
import {
  BannerAdd, BannerEdit, BannerDelete, BannerInfo, BannerUpLoadAttachment
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    CommonUploadEnclosure,
    FromComm,
    Upload,
    CommUploadAdditional
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number
    }
  },
  data: function () {
    return {
      dialogVisibleNewInformationAdd: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibleqy: false,
      dialogVisibLook: false,
      rowboo: false,
      ptype: '',
      type: '',
      zname: '',
      parentId: '',
      InfoID: '',
      InformationtextareaEdit: '',
      InformationtextareaAdd: '',
      fromdataadd: [],
      fromdataedit: [],
      FromArr: [],
      FromArrsAll: [],
      resdetailsList: {},
      qus: [],
      filesInPutsArr: [],
      ObjName: [],
      ObjectID: [],
      fileURL: null,
      fileData: null,
      selectData: [],
      InfoObjectData: null,
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false
      },
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 80
      },
      {
        prop: 'Title',
        label: '标题',
        columnwidth: 250
      },
      // {
      //   prop: 'InfoContent',
      //   label: '发布对象',
      //   columnwidth: 180
      // },
      {
        prop: 'LinkUrl',
        label: '外链地址',
        columnwidth: 540
      },
      // {
      //   prop: 'FileName',
      //   label: '附件文件名',
      //   columnwidth: 170
      // },
      // {
      //   prop: 'Extension',
      //   label: '附件扩展名',
      //   columnwidth: 170
      // },
      {
        prop: 'CreatorName',
        label: '发布人',
        columnwidth: 180
      },
      {
        prop: 'CreateTime',
        label: '发布时间',
        columnwidth: 263
      },
      ],
      FromArrs: [
        {
          title: "Barnner标题：",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          lablewidth: 100,
          types: "text",
          placeholder: "请输入Barnner标题",
          width: 300,
          height: 32,
          disabled: false,
          marginLeft: 30,
          marginTop: 0,
          X: false,
          displayVal: "inline-block",
          fontWeightVal: 500
        },
        {
          title: "Barnner内容：",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          lablewidth: 100,
          types: "text",
          placeholder: "请输入Barnner内容",
          width: 300,
          height: 32,
          disabled: false,
          marginLeft: 60,
          marginTop: 0,
          X: false,
          displayVal: "inline-block",
          fontWeightVal: 500
        },
        {
          title: "Barnner外链：",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          lablewidth: 100,
          types: "text",
          placeholder: "请输入Barnner外链",
          width: 300,
          height: 32,
          disabled: false,
          marginLeft: 30,
          marginTop: 20,
          X: false,
          displayVal: "inline-block",
          fontWeightVal: 500
        },

        // title: "经销商名称：",
        // inputtype: "input",
        // inputflag: true,
        // fontSize: 14,
        // color: "#333333",
        // lableheight: 20,
        // X: false,
        // types: "text",
        // placeholder: "请输入",
        // width: 190,
        // height: 32,
        // disabled: false,
        // marginLeft: 25,
        // marginTop: 30,
        // displayVal: "inline-block",
        // fontWeightVal: 500

      ],

    }
  },
  created() {
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.QX()
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    getSingleSelectedRow(actionName) {
      if (this.selectData.length !== 1) {
        this.$message.warning(`请勾选一条数据进行${actionName}！`);
        return null;
      }
      return this.selectData[0];
    },
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        if (item.NodeID == 74) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 75) {
              this.qus = items.Nodes
            }
          })
        }
      })
      this.qus.map((item, index) => {
        if (item.NodeName == 'add') {
          this.qx.add = true
        } else if (item.NodeName == 'edit') {
          this.qx.update = true
        } else if (item.NodeName == 'delete') {
          this.qx.del = true
        } else if (item.NodeName == 'stopif') {
          this.qx.del = true
        } else if (item.NodeName == 'assignment') {
          this.qx.assignment = true
        }
      })

    },
    // 上传附件
    async BannerUpLoadAttachment(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        formData.append("file", file)
        let res = await BannerUpLoadAttachment(formData)
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.message
          })
          this.fileURL = res.data.FileUrl
          this.fileData = res.data
          loading.close();
        } else if (res.code == 101) {
          this.$message({
            type: 'warning',
            message: res.message
          })
          loading.close();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        loading.close();
      }
    },
    DataManageAddUpload(file) {
      this.BannerUpLoadAttachment(file)
    },
    // 新增
    async BannerAdd() {
      let {
        code,
        message,
        data
      } = await BannerAdd({
        title: this.FromArrs[0].modelvalue,
        infoContent: this.FromArrs[1].modelvalue,
        linkUrl: this.FromArrs[2].modelvalue,
        attachment: this.fileData,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.$parent.BannerList()
        this.dialogVisibleNewInformationAdd = false
      } else {
        this.$message({
          type: 'error',
          message: message
        });

      }
    },
    // 修改
    async BannerEdit() {
      let {
        code,
        message
      } = await BannerEdit({
        infoID: this.InfoID,
        title: this.FromArrs[0].modelvalue,
        infoContent: this.FromArrs[1].modelvalue,
        linkUrl: this.FromArrs[2].modelvalue,
        attachment: this.fileData,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.dialogVisiblesedit = false
         this.$parent.BannerList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });

      }
    },
    // 查询详情
    async BannerInfo() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await BannerInfo({
        InfoID: this.InfoID
      })
      if (code == 0) {
        this.dialogVisiblesedit = true
        this.FromArrs[0].modelvalue = data.Title
        this.FromArrs[1].modelvalue = data.InfoContent
        this.FromArrs[2].modelvalue = data.LinkUrl
        this.fileURL = data.Attachment.FileUrl
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 删除 
    async BannerDelete() {
      let {
        code,
        message
      } = await BannerDelete({
        infoID: this.InfoID,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.dialogVisibledel = false
         this.$parent.BannerList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
        this.dialogVisibledel = false
      }
    },
    onRowClick(val) {
      this.rowboo = true
      this.InfoID = val.InfoID

    },
    adduser() {
      this.dialogVisibleNewInformationAdd = true
    },
    cancelNewInformation() {
      this.dialogVisibleNewInformationAdd = false
    },
    dialogOKNewInformation() {
      this.BannerAdd()
    },
    updateclick() {
      const row = this.getSingleSelectedRow('修改');
      if (!row) return;
      this.InfoID = row.InfoID;
      this.rowboo = true;
      this.dialogVisiblesedit = true;
      this.BannerInfo();
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.BannerEdit()
      //console.log("upadate", this.$refs.deptupdate)
    },

    look() {
      if (this.rowboo == true) {
        this.InformationInfo('Info')
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要查看的数据！'
      });
    },
    cancelLook() {
      this.dialogVisibLook = false
    },
    dialogOKLook() {
      this.organizationDelete()
    },
    del() {
      const row = this.getSingleSelectedRow('删除');
      if (!row) return;
      this.InfoID = row.InfoID;
      this.rowboo = true;
      this.dialogVisibledel = true;
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.BannerDelete()
    },
    handleCurrentChange(PageIndex) {
      this.$emit('handleCurrentChange', PageIndex)
    },
    handleSizeChange(PageSize) {
      this.$emit('handleSizeChange', PageSize)
    },
    handleChange() {

    },
  },
  watch: {
    dialogVisiblesedit: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.FromArrs.map((item, index) => {
            item.modelvalue = '';
          })
          this.fileURL = '';
          this.fileData = null
        }
      }
    },
    dialogVisibleNewInformationAdd: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.FromArrs.map((item, index) => {
            item.modelvalue = '';
          })
          this.fileURL = '';
          this.fileData = null
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // flex-wrap: wrap;
  }
}
.CusBannerDialog {
  max-height: 632px;
  overflow-y: scroll;
  position: relative;
}
.textarea {
  margin-top: 16px;
}
.UploadFile {
  margin-left: -5px;
}

.remarks {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #9ca5b8;
}
/deep/.el-textarea__inner {
  height: 300px;
  width: 946px;
  margin-left: 5px;
}
/deep/.el-textarea__inner:focus {
  border: 1px solid #e71d43;
}
/deep/.el-textarea__inner:hover {
  border: 1px solid #e71d43;
}
.LookTop {
  width: 946px;
  height: 100%;
  // border: 1px solid red;
  margin: 0 auto;

  .LookTitle {
    height: 34px;
    font-size: 24px;
    font-weight: normal;
    color: #16181a;
    text-align: center;
  }
  .LookTime {
    height: 20px;
    font-size: 14px;
    font-weight: normal;
    color: #9ca5b7;
    text-align: center;
    margin-top: 10px;
  }
  .LookContext {
    width: 936px;
    font-size: 16px;
    font-weight: normal;
    color: #424e66;
    white-space: pre-wrap;
    margin-top: 50px;
  }
  p {
    margin-top: 49px;
  }
  .Line {
    width: 930px;
    height: 1px;
    background-color: #f2f3f5;
    margin-top: 24px;
    display: inline-block;
  }
  .LookFile {
    margin-top: 20px;
  }
}
</style>
